<div class="page-container">
    <h1>Error occurred</h1>
    <a [routerLink]="['']">Back to home page</a>
</div>
